import styled from 'styled-components';

const InfoTable = styled.div.attrs({
    className: 'container info-table',
})`
    .tableContainer {
        margin-bottom: 11px;
        border: solid 1.5px rgba(0,0,0, 0.12);
        border-radius: 20px;

        .rdt_TableRow, .sc-dmctIk {
            padding: 5px;
        }

        .sc-dmctIk {
            font-size: 16px;
        }


        .rdt_TableRow {
            font-size: 15px;
        }

        .row-label, .sc-dmctIk {
            font-weight: bold;
        }
    }
`;

export default InfoTable;
